"use server";

import { headers } from "next/headers";
import { redirect } from "next/navigation";
import { logInMetCode, logUit, vraagLinkAan, wisselLinkIn } from "@/server/leden-auth";
import { verwijderPasskey } from "@/server/passkeys";

// Wat een formulier op het Leden-gedeelte kan doen. Server Functions: het
// cookie zetten mag alleen hier of in een route.

export type AanvraagStaat = { uitkomst: "leeg" | "verstuurd" | "te-vaak" | "dicht" | "ongeldig" };

export async function vraagInloglinkAan(_: AanvraagStaat, formulier: FormData): Promise<AanvraagStaat> {
  const invoer = String(formulier.get("wie") ?? "").trim().slice(0, 120);
  if (!invoer) return { uitkomst: "ongeldig" };
  // Achter IIS komt het adres van de bezoeker in X-Forwarded-For.
  const h = await headers();
  const apparaat = h.get("x-forwarded-for")?.split(",")[0]?.trim() || h.get("x-real-ip") || "onbekend";
  return { uitkomst: await vraagLinkAan(invoer, apparaat) };
}

export type CodeStaat = { uitkomst: "leeg" | "fout" | "verlopen" };

/** De code uit de mail, ingetypt in de app zelf. */
export async function logInMetCodeActie(_: CodeStaat, formulier: FormData): Promise<CodeStaat> {
  const uitkomst = await logInMetCode(String(formulier.get("code") ?? "").slice(0, 20));
  if (uitkomst === "gelukt") redirect("/leden");
  return { uitkomst };
}

/** Een gekoppeld toestel loskoppelen; alleen een eigen passkey. */
export async function verwijderPasskeyActie(formulier: FormData): Promise<void> {
  await verwijderPasskey(String(formulier.get("id") ?? ""));
  redirect("/leden");
}

export async function logInMetLink(formulier: FormData): Promise<void> {
  const gelukt = await wisselLinkIn(String(formulier.get("code") ?? ""));
  redirect(gelukt ? "/leden" : "/leden?link=verlopen");
}

export async function logUitActie(): Promise<void> {
  await logUit();
  redirect("/leden");
}
